// src/components/TouchControls.js
import React from 'react';

function TouchControls({ onMove, onAttack, onInteract, onBomb, onInventoryCycle, onUseItem }) {
  const handleTouchStart = (action, e) => {
    e.preventDefault();
    action();
  };

  return (
    <div className="touch-controls">
      <div className="touch-movement">
        <button
          className="touch-button touch-up"
          onTouchStart={(e) => handleTouchStart(() => onMove('w'), e)}
          aria-label="Move Up"
        >
          ↑
        </button>
        <button
          className="touch-button touch-left"
          onTouchStart={(e) => handleTouchStart(() => onMove('a'), e)}
          aria-label="Move Left"
        >
          ←
        </button>
        <button
          className="touch-button touch-right"
          onTouchStart={(e) => handleTouchStart(() => onMove('d'), e)}
          aria-label="Move Right"
        >
          →
        </button>
        <button
          className="touch-button touch-down"
          onTouchStart={(e) => handleTouchStart(() => onMove('s'), e)}
          aria-label="Move Down"
        >
          ↓
        </button>
      </div>
      <div className="touch-actions">
        <button
          className="touch-button"
          onTouchStart={(e) => handleTouchStart(onAttack, e)}
          aria-label="Attack"
        >
          Attack
        </button>
        <button
          className="touch-button"
          onTouchStart={(e) => handleTouchStart(onInteract, e)}
          aria-label="Interact/Pickup"
        >
          E
        </button>
        <button
          className="touch-button"
          onTouchStart={(e) => handleTouchStart(onBomb, e)}
          aria-label="Use Bomb"
        >
          B
        </button>
        <button
          className="touch-button"
          onTouchStart={(e) => handleTouchStart(onInventoryCycle, e)}
          aria-label="Cycle Inventory"
        >
          I
        </button>
        <button
          className="touch-button"
          onTouchStart={(e) => handleTouchStart(onUseItem, e)}
          aria-label="Use Item"
        >
          U
        </button>
      </div>
    </div>
  );
}

export default TouchControls;